export default __webpack_public_path__ + "static/media/unicorn-primary.2ff5fa7acff5b0886a7def75fac6d25c.svg";